<template>
  <van-popup
    v-model="isShowItem"
    position="bottom"
    round
    :style="`border-top-left-radius: 0.48rem;border-top-right-radius: 0.48rem;${styleCss}`"
    @click-overlay="hide"
  >
    <div class="popup-content">
      <div class="header">
        <div class="icon-left" @click="hide"><i class="el-icon-arrow-left"></i></div>
        <div class="title">Payment Password</div>
      </div>
      <div class="payment-info">
        <div class="goods-name">Buy Apple Box</div>
        <div class="goods-price">$29</div>
      </div>
      <div class="input-box">
        <div
          class="code-item"
          :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''"
        >
          {{ codeValue[0] ? "*" : "" }}
        </div>
        <div
          class="code-item"
          :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''"
        >
          {{ codeValue[1] ? "*" : "" }}
        </div>
        <div
          class="code-item"
          :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''"
        >
          {{ codeValue[2] ? "*" : "" }}
        </div>
        <div
          class="code-item"
          :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''"
        >
          {{ codeValue[3] ? "*" : "" }}
        </div>
        <div
          class="code-item"
          :class="codeValue.length == 4 && inputFocus ? 'code-item-active' : ''"
        >
          {{ codeValue[4] ? "*" : "" }}
        </div>
        <div
          class="code-item"
          :class="codeValue.length >= 5 && inputFocus ? 'code-item-active' : ''"
        >
          {{ codeValue[5] ? "*" : "" }}
        </div>
        <input
          class="input-code"
          v-model="codeValue"
          autofocus
          :maxlength="6"
          type="number"
          @blur="codeInputBlur"
          @focus="codeInputFocus"
        />
      </div>
      <div class="keyboard-box">
        <van-number-keyboard
          :hide-on-click-outside="false"
          :maxlength="6"
          v-model="codeValue"
          :show="keyboardShow"
          @blur="keyboardShow = false"
          @input="onInput"
          @delete="onDelete"
        />
      </div>
    </div>
  </van-popup>
</template>
<script>
import Web3 from "web3";
import { validatePassword } from "@/axios/api/mrbox";
export default {
  props: {
    //弹框样式
    styleCss: {
      type: String,
      default: "min-height: 11.74rem;",
    },
    //显示
    isShow: {
      type: Boolean,
      default: false,
    },
    //详情数据
    details: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isShowItem: this.isShow,
      keyboardShow: true,
      codeValue: "",
      inputFocus: false,
    };
  },
  watch: {
    isShow() {
      this.isShowItem = this.isShow;
    },
    codeValue() {
      if (this.codeValue.length > 6) {
        // 假设限制长度为 5
        this.codeValue = this.codeValue.slice(0, 6);
      }
      this.codeInputChange();
    },
  },
  created() {
    console.log("支付传的数据", this.details);
  },
  methods: {
    hide(prams) {
      this.$emit("hide", prams);
    },
    onInput(value) {},
    onDelete() {},
    // 验证码输入框input
    codeInputChange() {
      if (this.codeValue && this.codeValue.length >= 6) {
        // do soming...
        console.log("验证码输入框input", this.codeValue);
        this.submit();
      }
    },
   async submit() {
      if (window.ethereum) {
        const web3 = new Web3(window.ethereum);
        let txObject = {
          from: "0x079f1ac8Af2f0638a16182f8Ef6D1aDEcC209B2d", //发送方地址
          to: "0x7EAdb4068481A071C64FaA999fd9A8d8931570f2", //接收方地址
          value: 1000000000000000, //金额
        }
        let getBalance= await web3.eth.getBalance('0x079f1ac8Af2f0638a16182f8Ef6D1aDEcC209B2d')
        console.log("getBalance", getBalance);
        let gasAmount =await web3.eth.estimateGas(txObject)
        console.log("gasAmount", gasAmount);
        const gasPrice = await web3.eth.getGasPrice();
        console.log("gasAmount", web3.utils.toWei("0.1", "ether"));
        
        let tx = {
          from: "0x079f1ac8Af2f0638a16182f8Ef6D1aDEcC209B2d", //发送方地址
          to: "0x7EAdb4068481A071C64FaA999fd9A8d8931570f2", //接收方地址
          value: web3.utils.toWei("0.1", "ether"), //金额
          gas:21000,
          gasPrice:gasPrice
        };
       await web3.eth
          .sendTransaction(tx)
          .on("receipt", async function (receipt) {})
          .then((res) => {
            console.log("成功", res);
          });
        return;
        validatePassword({ password: this.codeValue }).then((res) => {
          if (res.data == true) {
            let params = {
              sellId: this.details.goodsId, //商品id
              currentQuote: this.details.quote, //价格
              walletType: 9, //钱包类型usdt
            };

            // exchangeBuy(params).then((by) => {
            //   if (by.code == 200) {
            //     this.$toast.success("支付成功！");
            //     window.location.reload(); //刷新页面
            //   } else {
            //       this.$toast.fail(by.msg);
            //   }
            // });
          } else {
            this.$toast.fail("支付失败，密码错误！");
            this.codeValue = "";
          }
        });
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
      if(this.codeValue.length < 6){
        this.$toast.fail("请输入完整密码！");
      }else{
        this.submit();
      }
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      (this.keyboardShow = true), (this.inputFocus = true);
    },
  },
};
</script>
<style lang="scss" scoped>
.popup-content {
  min-height: 11.74rem;
  width: 100%;
  .header {
    height: 1.5rem;
    display: flex;
    align-items: center;
    padding: 3%;
    .icon-left {
      font-size: 0.5rem;
    }
    .title {
      width: 100%;
      font-size: 0.3rem;
      display: flex;
      justify-content: center;
    }
  }
  .payment-info {
    margin: 3%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .goods-name {
      font-size: 0.3rem;
    }
    .goods-price {
      color: #303030;
      font-size: 0.6rem;
      font-style: normal;
      margin: 6%;
      font-weight: 900;
    }
  }
  .input-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    padding: 0px 15px;
    box-sizing: border-box;

    .input-code {
      width: 100%;
      height: 1rem;
      position: absolute;
      left: 0px;
      top: 0px;
      box-sizing: border-box;
      color: transparent;
      background-color: transparent;
      opacity: 0;
    }

    .code-item {
      width: 0.8rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;

      background: #f3f5f7;
      margin-right: 0.2rem;
      color: #444;
      font-size: 0.68rem;
    }

    .code-item-active {
      border-bottom: 1px solid #ae6bf7;
    }
  }

  .text_1 {
    text-align: center;
    font-size: 0.25rem;
    margin-top: 0.3rem;

    .text_2 {
      color: rgba(200, 200, 200, 1);
    }

    .text_3 {
      color: rgba(174, 107, 247, 1);
    }
  }

  .keyboard-box {
  }
}
</style>
